import api from "./api";

export const listarAreaCobertura = async (data) => {
  try {
    const area = await api.get(`/estabelecimentos/${data}/area-cobertura`);
    return area.data;
  } catch (error) {
    throw error;
  }
};

export const buscarAreaCobertura = async (data, estabelecimento) => {
  try {
    const area = await api.get(
      `/estabelecimentos/${estabelecimento}/area-cobertura/busca?area=${data}`,
    );
    return area.data;
  } catch (error) {
    throw error;
  }
};

export const criarAreaCobertura = async (data, estabelecimento) => {
  try {
    const response = await api.post(
      `/estabelecimentos/${estabelecimento}/area-cobertura`,
      data,
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const removeAreaCobertura = async (id_area, estabelecimento) => {
  try {
    const response = await api.delete(
      `/estabelecimentos/${estabelecimento}/area-cobertura/${id_area}`,
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
